import { ursaColors, ursaColorsInternal } from "@smartsheet/design-tokens";
import { color } from "@smartsheet/design-tokens-react";
import { themed } from "@smartsheet/sds-theme-internal";
import { toRgba, neutralLight40, neutralDark40 } from "../../../constants/colors";

/**
 * These colors are intentionally all using Ursa colors for now. The
 * only difference is that Ursa does not have the separator between actions.
 *
 * Note: tokenizing these values will cause them to render differently in Lodestar themes, so for now we're using direct ursa colors usage.
 */
export const bannerTheme = themed({
  backgroundColor: {
    error: color("color--background--error--weak"),
    info: color("color--background--info--weak"),
    success: color("color--background--success--weak"),
    warning: color("color--background--warning--weak"),
    nonSemantic: color("color--background--neutral--weaker")
  },
  fontColor: {
    error: color("color--text--spectrum-red--default"),
    info: color("color--text--spectrum-azure--default"),
    success: color("color--text--spectrum-mint--default"),
    warning: color("color--text--spectrum-gold--default"),
    nonSemantic: color("color--text--neutral--default")
  },
  // The separator is set to `display: none` in Ursa, so some of this is a moot point
  separatorColor: {
    error: ursaColors.red200,
    info: ursaColors.azure200,
    success: ursaColors.mint200,
    warning: ursaColors.gold200,
    nonSemantic: ursaColors.neutral200
  },
  separatorDisplay: {
    "lodestar-light": "inline",
    "ursa-light": "none"
  },
  iconColor: {
    error: color("color--icons--error--default"),
    info: color("color--icons--info--default"),
    success: color("color--icons--success--default"),
    warning: color("color--icons--warning--default"),
    nonSemantic: color("color--text--neutral--default")
  },
  action: {
    padding: {
      "lodestar-light": "8px 4px",
      "ursa-light": "8px 12px"
    },
    borderRadius: {
      "lodestar-light": "4px",
      "ursa-light": "6px"
    },
    marginLeft: {
      "lodestar-light": 0,
      "ursa-light": "4px"
    },
    fontWeight: {
      "lodestar-light": 600,
      "ursa-light": 500
    },
    hoverBackground: {
      "lodestar-light": toRgba(neutralLight40, 0.2),
      "ursa-light": toRgba(ursaColorsInternal.slate800, 0.12)
    },
    pressBackground: {
      "lodestar-light": toRgba(neutralDark40, 0.12),
      "ursa-light": toRgba(ursaColorsInternal.slate800, 0.24)
    }
  }
});
//# sourceMappingURL=bannerTheme.js.map